import React from 'react';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDLink from '../../../../../../BaseComponents/Link/EDLink';

interface IReportingStatusProps {
  remainingCount: number;
  onClick: () => void;
}

export const ReportingStatus: React.FC<IReportingStatusProps> = ({
  remainingCount,
  onClick,
}) => {
  const allReported = remainingCount === 0;

  return (
    <EDBox
      display={'flex'}
      justifyContent={'center'}
      marginTop={'auto'}
      marginRight={'15px'}
      paddingBottom={'1px'}
      sx={{ cursor: 'pointer' }}
    >
      <EDLink onClick={!allReported ? onClick : undefined}>
        {allReported
          ? 'Inga aktiviteter att rapportera'
          : `Aktiviteter kvar att rapportera: ${remainingCount}`}
      </EDLink>
    </EDBox>
  );
};
